import * as React from 'react';
import {useDispatch} from 'react-redux';

import type {FilterObject} from 'nutshell-core/types';

import {DashboardCard} from 'shells/dashboard/card/dashboard-card';
import {getIllustration} from 'shells/onboarding-checklist/helpers';
import {PromoStateOverlay} from 'shells/promo-state-overlay/promo-state-overlay';

// @ts-expect-error
import {useGetChannelDashboard} from './graphql/hooks';
import * as actions from './report/whatsapp/whatsapp-actions';
import {WhatsAppChart} from './report/whatsapp/whatsapp-chart';

import styles from './dashboard.module.css';

const REPORT_PARAMS = {
    dateRangeType: 'period',
    facet: 'count',
    gap: 'd',
    segment: 'interactionType',
} as const;

type Props = {
    dateRange: string;
    activeFilters: FilterObject[];
    onParamChange: (arg1: any, arg2: boolean) => void;
    shouldShowPromo: boolean;
};

export function WhatsAppCard(props: Props) {
    const {activeFilters} = props;

    const {channelDashboard, isLoading} = useGetChannelDashboard({
        timespan: props.dateRange,
        channelType: 'whatsapp',
    });

    const dispatch = useDispatch();

    const stats = channelDashboard ? channelDashboard.stats : [];

    React.useEffect(() => {
        dispatch(
            actions.requestReportData({
                reportParams: REPORT_PARAMS,
                filters: activeFilters,
            })
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeFilters]);

    return (
        <DashboardCard
            title='WhatsApp'
            subtitle='Communicate with customers who message your WhatsApp account'
            isLoading={isLoading}
            mainContent={{
                statsProps: {stats},
                content: (
                    <div className={styles.chart}>
                        <WhatsAppChart
                            activeFilters={props.activeFilters}
                            onParamChange={props.onParamChange}
                            reportParams={REPORT_PARAMS}
                            height={346}
                            containerHeight={346}
                        />
                    </div>
                ),
            }}
            promoStateOverlay={
                props.shouldShowPromo && (
                    <PromoStateOverlay
                        promoStateProps={{
                            isHorizontal: true,
                            imageComponent: getIllustration('setupWhatsApp'),
                            title: 'Integrate WhatsApp With Nutshell',
                            subtitle:
                                'Connect your WhatsApp account to Nutshell to start engaging with customers who message your account.',
                            primaryCta: null,
                            secondaryCta: {
                                text: 'Integrate WhatsApp',
                                url: '/inbox/settings/whatsapp',
                            },
                            blueImageBackground: true,
                        }}
                    />
                )
            }
        />
    );
}
